import { render, staticRenderFns } from "./TheRemakePassword.vue?vue&type=template&id=3c9a2b35&"
import script from "./TheRemakePassword.vue?vue&type=script&lang=js&"
export * from "./TheRemakePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports